module.exports = __webpack_public_path__ + "img/help.55dcb69c.png";